export default {
  SET_DASHBOARD_DATA(state, data) {
    state.dashboardData = data;
    state.lastUpdate = new Date().getTime();
    localStorage.setItem('dashboardData', JSON.stringify(data));
    localStorage.setItem('dashboardLastUpdate', state.lastUpdate);
  },
  SET_LOADING_DASHBOARD(state, loading) {
    state.loadingDashboard = loading;
  },
  SET_LOADING_USERS(state, loading) {
    state.loadingUsers = loading;
  },
  SET_TOTAL_COLLABORATORS(state, total) {
    state.totalCollaborators = total;
  },
  RESET_DASHBOARD(state) {
    state.dashboardData = null;
    state.lastUpdate = null;
    state.loadingDashboard = false;
    state.loadingUsers = false;
    state.totalCollaborators = 0;
    state.associatedPanels = [];
    state.creditDistribution = {
      master_credit_limit: 0,
      panels: [],
    };
    state.creditDistributionLastUpdate = null;
    state.loadingAssociatedPanels = false;
    state.loadingCreditDistribution = false;
    localStorage.removeItem('associatedPanels');
    localStorage.removeItem('creditDistribution');
    localStorage.removeItem('creditDistributionLastUpdate');
  },
  SET_ASSOCIATED_PANELS(state, data) {
    state.associatedPanels = data;
    localStorage.setItem('associatedPanels', JSON.stringify(data));
  },
  SET_LOADING_ASSOCIATED_PANELS(state, loading) {
    state.loadingAssociatedPanels = loading;
  },
  SET_LOADING_CREDIT_DISTRIBUTION(state, loading) {
    state.loadingCreditDistribution = loading;
  },
  SET_CREDIT_DISTRIBUTION(state, data) {
    state.creditDistribution = data || {
      master_credit_limit: 0,
      panels: [],
    };
    localStorage.setItem('creditDistribution', JSON.stringify(state.creditDistribution));
  },
  SET_CREDIT_DISTRIBUTION_LAST_UPDATE(state, timestamp = null) {
    state.creditDistributionLastUpdate = timestamp;

    if (timestamp === null) {
      localStorage.removeItem('creditDistributionLastUpdate');
      return;
    }

    localStorage.setItem('creditDistributionLastUpdate', timestamp);
  },
};
